export default __webpack_public_path__ + "static/media/communication.3785b827.svg";